import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notifications: []
};

export const notificationSlice = createSlice({
  name: 'NOTIFICATION',
  initialState,
  reducers: {
    ENQUEUE_SNACKBAR: (state, action) => {
      state.notifications = [
        ...state.notifications,
        {
          key: action.key,
          ...action.notification
        }
      ];
    },
    CLOSE_SNACKBAR: (state, action) => {
      state.notifications = state.notifications.map(notification =>
        action.dismissAll || notification.key === action.key
          ? { ...notification, dismissed: true }
          : { ...notification }
      );
    },
    REMOVE_SNACKBAR: (state, action) => {
      state.notifications = state.notifications.filter(
        notification => notification.key !== action.key
      );
    }
  }
});

export default notificationSlice.reducer;
